import { render } from "./cpt-tab-option.vue?vue&type=template&id=0baff27c&scoped=true"
import script from "./cpt-tab-option.vue?vue&type=script&lang=js"
export * from "./cpt-tab-option.vue?vue&type=script&lang=js"

import "./cpt-tab-option.vue?vue&type=style&index=0&id=0baff27c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baff27c"]])

export default __exports__